<div class="custom-dialog-container bg-white d-flex flex-column h-100 w-100">
    <!-- Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
        <h5 class="m-0 font-weight-600" style="font-size: 15px; color: #111827;" *ngIf="title">{{ title }}</h5>
        <div class="header-content d-flex flex-1" *ngIf="!title">
            <ng-content select="[popup-header]"></ng-content>
        </div>
        <kt-button-v1 *ngIf="showCloseIcon" variant="icon" icon="close" tooltip="Close"
            (btnClick)="close.emit()"></kt-button-v1>
    </div>

    <!-- Body -->
    <div class="dialog-body px-4 py-4 flex-grow-1" style="overflow-y: auto;">
        <ng-content select="[popup-body]"></ng-content>
        <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div class="dialog-footer px-4 py-3 border-top bg-white align-items-center mt-auto w-100"
         [style.display]="hasFooter && showFooterContent ? 'flex' : 'none'">
        <div #footerWrapper class="w-100" style="display: contents;">
            <ng-content select="[popup-footer]"></ng-content>
        </div>
    </div>
</div>
